import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import './messagerie.css';
import {BrowserView, isBrowser, isMobile, MobileView} from "react-device-detect";
import Select from "react-select";
import { useWindowHeight } from "@react-hook/window-size";
import { MessageBox, Input} from 'react-chat-elements';
import { ButtonLoader } from "../../utils/Loaders/ButtonLoader";
import { useFetch } from "../../api/FetchApiData";
import { useInfiniteScroll } from "../../utils/InfiniteScroll";
import { data, useNavigate, useParams } from "react-router-dom";
//import WsNotifications from "../../api/WsNotifications";
import './iswritting.css';
import { UserContext } from "../../../AppContextProvider";

if (isMobile)
    import('./messagerie_mob.css').then(() => {});
else
    import('./messagerie.css').then(() => {});



export function Message({mess,index, defaultWidth='100%'})
{

    const date = new Date(mess.time);
    const time = date.getTime();
    let maxWidth = defaultWidth;
    const [sender,setSender] = useState({self:false, name:'unknown',color:'white'});
    const [UserState,setUserState] = useContext(UserContext);

    useEffect(()=>{
        if(mess.auto)
        {setSender({self:false,name:'Rikinaze',color:'#B8E2F4'});}
        else if(!!UserState.id && !!mess.sender && UserState.id===mess.sender.id)
        {setSender({self:true,name:'Vous',color:'#CBFFCB'});}
        else if(!!UserState.id && !!mess.sender && UserState.id!==mess.sender.id)
        {setSender({self:false,name:mess.sender.name,color:'#B8E2F4'});}
        else if(UserState.is_staff && !mess.from_staff)
        {setSender({self:false,name:mess.sender.name,color:'#B8E2F4'});}
        else if(!UserState.is_staff && !mess.from_staff)
        {setSender({self:true,name:'Vous',color:'#CBFFCB'});}
        else
        {setSender({self:true,name:'Vous',color:'#CBFFCB'});}
        
    },[UserState.auth])

    if(isMobile)
        maxWidth = '80%';
    if(!sender.self)
    {
        return(  
            <div style={{width:'100%',margin:'auto',paddingLeft:'10px',paddingRight:'10px',display:'block'}}>                                    
                <MessageBox
                    position={'left'}
                    type={'text'}
                    title={sender.name}
                    className="user-messagerie-messagebox"
                    styles={{maxWidth:maxWidth,textAlign:'left',backgroundColor:sender.color}}
                    text={mess.text}
                    date={mess.time}
                />
            </div>
        );
    }
    else
    {
        return(                     
            <div style={{width:'100%',margin:'auto',paddingRight:'10px'}}>                 
                <MessageBox
                    position={'right'}
                    type={'text'}
                    title={sender.name}
                    styles={{maxWidth:maxWidth,backgroundColor:sender.color,textAlign:'left'}}
                    text={mess.text}
                    date={mess.time}
                />
            </div>  
            );
    }
}

const IsWritting = ({text=""})=>{
    return(<div className='dots-loader'>
        <span></span>
        <span></span>
        <span></span>
        <label style={{color:'lightgray',fontSize:'x-small',width:'200px'}}>{text}</label>
    </div>)
}

export default function Messagerie({User, con_number=null})
{
    const [newMessage,setNewMessage] = useState({text:''});
    const [_User,_setUser] = useState(User);
    const [UserState,setUserState] = useContext(UserContext);
    const [messages, setMessages_] = useState([]);
    const fetchData = useFetch();
    const [page,setPage] = useState({CurrentPage:1,MaxPage:10});
    const [hasMore,setHasMore] = useState(true);
    //const [messBottomMargin,setMessBottomMargin] = useState('60px');
    const {number} = useParams();
    const [convNumber,setConvNumber] = useState(con_number || number);
    const inputDivRef = useRef();
    const [TextAreaMaxHeight,setTextAreaMaxHeight] = useState("48px");
    const [sLoading,setSLoading] = useState(false);
    const ref_messeages = useRef(null);
    const bottom_ref = useRef(null);
    const [typing,setTyping] = useState({status:false,text:""});

    /*
    const onMessage = (data)=>
    {
        if(!!data['message'])
        {
            ref_messeages.current.push(data.message);
            setMessages_([...ref_messeages.current]);
        }
        else if(!!data["typing"])
        {
            setTyping({status:true,text:data.id+" est entrain d'écrire"});
            setTimeout(()=>{setTyping({status:false,text:''});},10000);
        }
        setTimeout(()=>{bottom_ref.current?.scrollIntoView({behavior:"smooth"})},1000);
    }
    */
    useEffect(()=>{
        const AppTimer  = setInterval(()=>{
            let _mess = messages.map(m=>m.id);
            fetchData.PostData({messages:_mess,id:convNumber,request:'check_message'},
                'user/conversations/').then((result)=>{
                    console.log(result,UserState);
                    if(result.result && !!result.messages)
                        setMessages_([...messages,...result.messages]);

                });},10000
        );
        return ()=>clearInterval(AppTimer);
        /*
        const _data = {add_chat:true, chat_channel:convNumber};
        console.log(!WsNotifications.is_online())
        if(!WsNotifications.is_online())
        {
            const onConnected = ()=>{
                WsNotifications.send(_data);
            }
            console.log(convNumber);
            WsNotifications.connect(false,onConnected,convNumber,"messagerie");    
        }
        else{
            WsNotifications.send(_data);
        }
        WsNotifications.onMessage(onMessage);
        setTimeout(()=>{bottom_ref.current?.scrollIntoView({behavior:"smooth"})},1000);
        return ()=>{
            const _data = {discard_chat:true}
            if(WsNotifications.is_online())
                WsNotifications.send(_data)
        }
        */
    },[]);

    useEffect(()=>
        {
            fetchData.Authenticate(UserState,setUserState);
            const AppTimer  = setInterval(()=>{fetchData.Authenticate(UserState,setUserState);},60000);
            return ()=>clearInterval(AppTimer);
    },[])


    const FetchMessages = useCallback(async ()=>{
        if(!hasMore)
            return
        let id = convNumber;
        if(page.CurrentPage<=page.MaxPage)
        {
            fetchData.GetData(`user/messaging/${id}/${page.CurrentPage}/`).then((result)=>{
                if(result.result)
                {
                    console.log(result.result);
                    if(page.CurrentPage>result.maxpage)
                        setHasMore(false);
                    else
                    {
                        console.log('loaded ...');
                        setMessages_([...messages,...result.messages]);
                        setPage({...page,CurrentPage:page.CurrentPage+1,MaxPage:result.maxpage});
                    }

                }
                else{
                    
                }
            })
        }
    },[page, hasMore]);

    const LoadMoreRef = useInfiniteScroll(FetchMessages,hasMore);

    useEffect(()=>{
        ref_messeages.current = messages;
    },[messages])


    const SendMessage=()=>
    {
        let _data = {messag_chat:true, text:newMessage.text, datetime:Date.now(),conversation_number:convNumber};
        if(UserState.auth)
            _data['sender'] = UserState.id
        fetchData.PutData(_data,'user/conversations/').then((result)=>{
            if(result.result)
            {
                messages.push(result.tx);
                if(!!result.rx)
                    messages.push(result.rx);
                setMessages_([...messages]);
            }
        })
        setNewMessage({text:""});
        setTextAreaMaxHeight("40px");
        //setMessBottomMargin('55px');
    }

    const SendTyping=()=>
    {
        let _data = {typing:true};
        if(!!UserState.id)
            _data['id'] = UserState.id
    }

    return(
        <div className="user-messagerie" style={{height:'100vh',backgroundColor:'white'}}>
            <div ref={inputDivRef} className="user-messagerie-input">                
            {
                <>
                    <BrowserView style={{width:'100%'}}>
                        <textarea 
                            style={{borderRadius:'5px',display:'inline-block',border:'1px solid black',width:'75%',minHeight:'45px',verticalAlign:'middle',maxHeight:'60px'}}
                            placeholder='Taper votre message'
                            multiline
                            value={newMessage.text}
                            onChange={(e)=>{
                                setNewMessage({text:e.target.value});
                                setTextAreaMaxHeight(e.target.scrollHeight+'px');
                                e.target.style.height = 'auto';
                                e.target.style.height = e.target.scrollHeight+'px';
                                //SendTyping();
                            }}
                        />
                        <div className="user-button-submit-message" style={{height:'50px',fontSize:'small',width:'20%',display:'inline-block',margin:'auto',marginLeft:'5px'}}>
                            <ButtonLoader loading={sLoading} onSubmit={e=>{SendMessage();}} style={{backGroundColor:'lightgreen',fontSize:'smaller'}} text={'Envoyer'} />
                        </div>
                    </BrowserView>
                    <MobileView style={{width:'96%',display:'flex',flexDirection:'row'}}>
                        <textarea 
                            style={{borderRadius:'5px',border:'1px solid lightgray',width:'75%',minHeight:'45px',verticalAlign:'middle',maxHeight:TextAreaMaxHeight}}
                            placeholder='Taper votre message'
                            multiline
                            value={newMessage.text}
                            onChange={(e)=>{
                                setNewMessage({text:e.target.value});
                                setTextAreaMaxHeight(e.target.scrollHeight+'px');
                                e.target.style.height = 'auto';
                                //e.target.style.height = e.target.scrollHeight+'px';
                                //setMessBottomMargin(inputDivRef.current.scrollHeight+5+'px');
                                SendTyping();
                            }}
                        />
                        <div style={{height:TextAreaMaxHeight,marginLeft:'5px',width:'20%',padding:'0px 5px 0px 5px'}}>
                            <ButtonLoader loading={sLoading} onSubmit={e=>{SendMessage();}} style={{backGroundColor:'lightgreen'}} text={'Envoyer'} />
                        </div>
                    </MobileView>
                </>
            }
            </div>
            <MobileView>
                <div className="user-messagerie-messages" style={{width:'98%',textAlign:'center',maxHeight:'70vh',paddingTop:'150px',margin:'auto',overflowY:'auto',overflowX:'hidden',position:'relative',bottom:'10px'}}>
                    <div ref={LoadMoreRef}  style={{width:'100%',textAlign:'center'}} />
                    {
                        messages.map((mess, index)=>{
                            return(
                                <Message key={index} mess={mess} index={index} />
                            )
                        })
                    }
                    <div ref={bottom_ref} style={{maxHeight:'10px',width:'50%',paddingLeft:'20px',margin:'2px'}}>
                        {typing.status && <IsWritting />}
                    </div>
                </div>
            </MobileView>
            <BrowserView style={{width:'100%',height:'80%'}}>
                <div className="user-messagerie-messages" style={{height:'100%',width:'100%',textAlign:'left',position:'relative'}}>
                    <div ref={bottom_ref} style={{maxHeight:'10px',width:'20%',paddingLeft:'50px',margin:'2px'}}>
                        { typing.status && <IsWritting />}
                    </div>
                    {
                        messages.map((mess, index)=>{
                            return(
                                <Message key={index} mess={mess} index={index} />
                            )
                        })
                    }
                    <div ref={LoadMoreRef}  style={{height:'20px',margin:'auto',width:'100%'}} />
                </div>
            </BrowserView> 
        </div>
    );    
}